import React from "react";
import { Star, MapPin, Heart } from "lucide-react";

const STATUS = {
  open: "bg-[#00E676]/20 text-[#00E676] border-[#00E676]/30",
  arriving: "bg-[#7DF9FF]/20 text-[#7DF9FF] border-[#7DF9FF]/30",
  closed: "bg-white/10 text-white/70 border-white/20",
};

// Card risultato riutilizzabile per tutte le pagine-lista.
export default function ResultCard({
  testid, image, fallbackIcon: Fallback, title, subtitle, statusLabel, statusType = "open",
  distance, rating, priceTier, extraBadge, onOpen, onMap, isFavorite, onFavorite,
}) {
  return (
    <div
      data-testid={testid}
      onClick={onOpen}
      className="rounded-2xl bg-[#131316] border border-white/10 overflow-hidden flex flex-col transition-colors duration-300 hover:border-[#00E676]/40 group cursor-pointer"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden bg-[#1C1C1F]">
        {image ? (
          <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white/20">{Fallback && <Fallback className="h-10 w-10" />}</div>
        )}
        <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
          {statusLabel && <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold backdrop-blur-md border ${STATUS[statusType]}`}>{statusLabel}</span>}
          {extraBadge && <span className="px-2.5 py-0.5 rounded-full text-xs font-semibold backdrop-blur-md border bg-[#FFD700]/20 text-[#FFD700] border-[#FFD700]/30">{extraBadge}</span>}
        </div>
        {onFavorite && (
          <button
            data-testid={`${testid}-fav`}
            onClick={(e) => { e.stopPropagation(); onFavorite(); }}
            className="absolute top-3 right-3 h-8 w-8 rounded-full bg-black/40 backdrop-blur-md border border-white/15 flex items-center justify-center hover:bg-black/60"
            aria-label="Preferito"
          >
            <Heart className={`h-4 w-4 ${isFavorite ? "fill-[#00E676] text-[#00E676]" : "text-white"}`} />
          </button>
        )}
      </div>
      <div className="p-4 flex flex-col gap-2 flex-grow">
        <div className="flex justify-between items-start gap-2">
          <h3 className="font-bold text-white leading-tight truncate">{title}</h3>
          {priceTier && <span className="text-sm text-white/50 shrink-0">{priceTier}</span>}
        </div>
        {subtitle && <p className="text-sm text-white/50 truncate">{subtitle}</p>}
        <div className="flex items-center gap-4 text-xs text-white/50">
          {rating > 0 && <span className="flex items-center gap-1"><Star className="h-3.5 w-3.5 fill-[#FFD700] text-[#FFD700]" /> {Number(rating).toFixed(1)}</span>}
          {distance && <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {distance}</span>}
        </div>
        {onMap && (
          <div className="mt-auto pt-3 border-t border-white/10">
            <button
              data-testid={`${testid}-map`}
              onClick={(e) => { e.stopPropagation(); onMap(); }}
              className="text-xs font-semibold text-[#00E676] hover:text-[#00E676]/80 flex items-center gap-1.5"
            >
              <MapPin className="h-3.5 w-3.5" /> Vedi sulla mappa
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
